import React from 'react';
import { Row, Column, SupportEmail, SupportPhone, SupportHoursV2, Margin } from '@upgrade/react-components';
import { CUSTOMER_SUPPORT } from '@upgrade/ui-utils/constants/departments';
import { Trans } from '@lingui/react';
import { StyledContainer, StyledImg } from './styles';
import { Section } from '../styles';
import { Heading, Text } from '../TypographyPublicSite';
import Fluid from '../../Fluid';

const ContactInfo = ({ contact: { departmentName } = {}, padding = 'md', borderless }) => {
  const department = departmentName || CUSTOMER_SUPPORT;
  return (
    <Section borderless={borderless} padding={padding}>
      <Fluid padding="none">
        <StyledContainer>
          <Row xsVerticalAlign="top" smVerticalAlign="middle">
            <Column xs={4} xsHorizontalAlign="center" smHorizontalAlign="end">
              <StyledImg src="/img/need-help.png" alt="chat bubbles" />
            </Column>
            <Column xs={8}>
              <Row xsVerticalAlign="middle">
                <Column xs={12} sm={4}>
                  <Heading as="h2" size="sm" marginBottom="xs">
                    <Trans id="contact.needHelp" message="Need Help?" />
                  </Heading>
                  <Text as="p" size="sm" color="contentWeak" marginBottom="none">
                    <Trans id="contact.emailUs" message="Email us at" />
                  </Text>
                  <Margin bottom="md">
                    <SupportEmail {...{ department }} />
                  </Margin>
                </Column>
                <Column xs={12} sm={7}>
                  <Text size="sm" as="p" color="contentWeak" marginBottom="none">
                    <Trans id="contact.orCallUs" message="Or call us at" />
                  </Text>
                  <SupportPhone {...{ department }} />
                  <Text size="sm" as="p" color="contentWeak" marginBottom="none">
                    <SupportHoursV2 {...{ department }} />
                  </Text>
                </Column>
              </Row>
            </Column>
          </Row>
        </StyledContainer>
      </Fluid>
    </Section>
  );
};

export default ContactInfo;
